import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Loadable from "react-loadable";
import { get, find } from "lodash";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import { getPaymentInfo } from "~/store/totalData/actions";
import { partnerInfo } from "~/configs/partnerDetails";
const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const PaymentFeeResultPageMobile = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "home_mobile" */ "~/components/desktop/pages/PaymentFeeResult"
    ),
  loading: LoadableLoading
});
const PaymentFeeResultPageDesktop = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "home_desktop" */ "~/components/desktop/pages/PaymentFeeResult"
    ),
  loading: LoadableLoading
});

class DetectPaymentFeeResult extends Component {
  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const {
      match: {
        params: { code }
      }
    } = this.props;
    const mpTransaction = urlParams.get("mpTransaction");
    if (mpTransaction !== null) {
      this.props.getPaymentInfo(mpTransaction, "payment");
    } else if (code !== undefined) {
      this.props.getPaymentInfo(code, "", 2);
    }
  }

  render() {
    const { device } = this.props;
    return (
      <React.Fragment>
        {device === "mobile" ? (
          <PaymentFeeResultPageMobile {...this.props} {...this.methods} />
        ) : (
          <PaymentFeeResultPageDesktop {...this.props} {...this.methods} />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    totalData: { paymentInformation, loading }
  } = state;
  return {
    device: type,
    paymentInformation,
    loading
  };
};

const PaymentFeeResultHelmet = withTitle({
  component: DetectPaymentFeeResult,
  title: `${hospitalName.value} | Kết quả thanh toán viện phí`
});

export default connect(mapStateToProps, { getPaymentInfo })(
  withRouter(PaymentFeeResultHelmet)
);
